export default __webpack_public_path__ + "static/media/XMLID 306.d81d6f16.svg";